import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  dataviz1,
  dataviz2,
  dataviz3,
  dataviz4,
  dataviz5,
  dataviz6,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_4xl,
  font_family_weight_medium,
  font_md,
} from 'ext-ui/style/typography'
import styled, { css } from 'styled-components'

export const ChartFrame = styled.figure<{
  $embedded?: boolean
  $fitToContainer?: boolean
}>`
  width: 100%;
  min-width: 0;
  min-height: 320px;
  margin: 0;
  padding: ${spacing(4)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(2)};
  background: ${base_colorRaisedSurface};
  color: ${text_colorTextPrimary};

  ${({ $embedded }) =>
    $embedded &&
    css`
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 0;
      border: 0;
      border-radius: 0;
      background: transparent;
    `}

  ${({ $fitToContainer }) =>
    $fitToContainer &&
    css`
      height: 100%;
    `}
`

export const ChartSurface = styled.div<{ $fitToContainer?: boolean }>`
  width: 100%;
  min-width: 0;
  height: 320px;

  ${({ $fitToContainer }) =>
    $fitToContainer &&
    css`
      flex: 1;
      min-height: 0;
      height: 100%;
    `}

  > svg {
    display: block;
    overflow: visible;
  }
`

export const ChartValue = styled.p`
  margin: 0;
  ${font_4xl};
  font-family: ${font_family_weight_medium};
`

export const ChartCaption = styled.figcaption`
  margin-top: ${spacing(3)};
  color: ${text_colorTextSecondary};
  ${font_md};
`

export const interactiveLinePoint = css`
  cursor: pointer;

  &:focus-visible {
    outline: none;
    fill: ${base_colorRaisedSurface};
    stroke: ${text_colorTextPrimary};
    stroke-width: 2;
  }
`

export const reportingTooltipViewport = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-width: min(236px, calc(100vw - 8px));
  max-width: calc(100vw - 8px);
  max-height: min(320px, calc(100vh - 8px));
  overflow: hidden;
  pointer-events: auto;
`

export const reportingTooltipSeriesList = css`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
`

export const chartColors = [
  dataviz1,
  dataviz2,
  dataviz3,
  dataviz4,
  dataviz5,
  dataviz6,
] as const
